import classNames from 'classnames/bind';
import styles from './ThreePicture.module.scss';
import imgright from '~/assets/imgtopgroup.jpg'; // Import avatar image
import imgright3 from '~/assets/FB_IMG_1691804982776.jpg'; // Import avatar image
import { getData } from '~/helper/apiService';
import { useEffect, useState } from 'react';
import images from '~/assets';

const cx = classNames.bind(styles);

function ThreePicture() {
  const [counter, setCounter] = useState(0);

  const loadCounter = async () => {
    const res = await getData('/user/getcounter');
    let countInfo;
    if (res.length > 0) {
      countInfo = res[0]
      setCounter(countInfo.count);
    }
    if (!countInfo) return;
    // if old access alredy exit
    let accessCode = localStorage.getItem('access_code');
    const today = new Date().toISOString().split('T')[0]; 
    const countCode =  `${countInfo.code}_${today}`;

    if (!accessCode) {
      localStorage.setItem('access_code', countCode);
    }
    if (accessCode !== countCode) {
      localStorage.setItem('access_code', countCode);
      await getData('/user/addcounter');
      setCounter(prev=>prev + 1)
    }
    
    console.log('countInfo', countInfo);
    console.log('accessCode', accessCode , countCode);
  };

  useEffect(() => {
    loadCounter();
  }, []);
  useEffect(() => {
    console.log('counter updated:', counter);
  }, [counter]);



  return (
    <div className={cx('wrapper')}>
      <div className={cx('left')}>
        <div className={cx('top')}>
          <img alt="" className={cx('img')} src={imgright3} />
        </div>
        <div className={cx('bottom')}>
          <img alt="" className={cx('img')} src={imgright} />
          <div className={cx("acess")}>
            <span>Lượt truy cập</span>
           <span>{counter}</span>
          </div>
        </div>
      </div>
      <div className={cx('right')}>
        <img alt="" className={cx('img')} src={images.hiimg} />
      </div>
    </div>
  );
}

export default ThreePicture;
